import React, { Component } from "react";
import Slider from "react-slick";
import Slide from "./slide";
import './index.css';

const carsImages = [
    {
        carImage: 'ferrari__black.jpg',
        switcherImage: 'paint-swatch__black.png',
        switcherBorder: 'none',
        name: 'black'
    },
    {
        carImage: 'ferrari__black-gold.jpg',
        switcherImage: 'paint-swatch__black.png',
        switcherBorder: 'gold',
        name: 'black-gold'
    },
    {
        carImage: 'ferrari__black-red.jpg',
        switcherImage: 'paint-swatch__black.png',
        switcherBorder: 'red',
        name: 'black-red'
    },
    {
        carImage: 'ferrari__black-white.jpg',
        switcherImage: 'paint-swatch__white.png',
        switcherBorder: 'black',
        name: 'black-white'
    },
    {
        carImage: 'ferrari__red-black.jpg',
        switcherImage: 'paint-swatch__red.png',
        switcherBorder: 'black',
        name: 'red-black'
    }
]
class CarSlider extends Component {

    settings = {
        customPaging: function(i) {
            return (
                <div className={`switcher__${i}`} style={{border: (carsImages[i].switcherBorder == 'none' ? 'none' : ''), borderColor: carsImages[i].switcherBorder}} onClick={this.dotsClick}>
                    <img src={require(`../../../image/${carsImages[i].switcherImage}`)} alt=""/>
                </div>
            );
        },
        dots: true,
        dotsClass: "slick-dots switchers",
        fade: true,
        arrows: false,
        controls: false,
        swipe: false,
        autoplay: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: current => this.dotsClick(current)
    };
    
    dotsClick = (current) => {
        this.props.onSliderChangeColor(carsImages[current].name)
    }

  render() {
    return (
        <React.Fragment>
            <div className='car-slider'>
                <Slider {...this.settings}>
                    {
                        carsImages.map((car, index)=> {
                            return <Slide key={index} carProperty={car}/>
                        })
                    }
                </Slider>
            </div>
        </React.Fragment>
    );
  }
}
export default CarSlider;